import { useAuth } from '../hooks/useAuth.jsx';
import { BrandStripe } from './BrandStripe.jsx';
import { Button } from './Button.jsx';

export const Header = () => {
  const { user, logout } = useAuth();
  return (
    <header class="border-b border-border-subtle bg-bg-header">
      <div class="mx-auto flex h-14 max-w-7xl items-center justify-between px-6">
        <a href="/" class="flex items-center gap-3">
          <BrandStripe />
          <span class="font-serif text-[17px] font-medium text-text-primary">
            brandpack tools
          </span>
        </a>
        {user && (
          <div class="flex items-center gap-4 text-[13px] font-medium text-text-tertiary">
            <span class="hidden items-center gap-2 sm:flex">
              <span
                class="block rounded-full"
                style={{ background: '#7BD4A8', width: 7, height: 7 }}
                aria-hidden="true"
              />
              online
            </span>
            <span class="hidden md:inline">
              {user.displayName} · {user.role}
            </span>
            <Button variant="secondary" onClick={logout} class="py-1.5 text-[13px]">
              Sign out
            </Button>
          </div>
        )}
      </div>
    </header>
  );
};
